import React from 'react';
import { ThemeProvider, createTheme, useTheme } from "@mui/material/styles";
import { Box, Grid, Typography, Link, Stack } from '@mui/material';

const LocalLinkThemeWrapper = ({ children }) => {
    const baseTheme = useTheme();

    const localTheme = createTheme({
        ...baseTheme,
        components: {
            ...baseTheme.components,
            MuiLink: {
                styleOverrides: {
                    root: {
                        textDecoration: "none",
                        color: baseTheme.palette.text.primary,
                        "&:hover": {
                            color: baseTheme.palette.text.primary,
                        },
                    },
                },
            },
        },
    });

    return <ThemeProvider theme={localTheme}>{children}</ThemeProvider>;
};

const Footer = () => {
    const theme = useTheme();

    return (
        <LocalLinkThemeWrapper>

            <Box
                component="footer"
                sx={{
                    backgroundColor: theme.palette.background.secondPaper,
                    borderTop: `1px solid ${theme.palette.divider}`,
                    px: { xs: 2, sm: 4, md: 10 },
                    py: 3,
                }}
            >
                <Grid container spacing={6}>
                    <Grid>
                        <Typography variant="h6" gutterBottom
                            sx={{
                                color: theme.palette.accent.main
                            }}>
                            Stylisher
                        </Typography>
                        <Stack spacing={1} mx={1}>
                            <Link href="/about-us">About Us</Link>
                            <Link href="/updates">Updates</Link>
                            <Link href="/privacy-policy">Privacy Policy</Link>
                            <Link href="/terms-of-service">Terms of Service</Link>
                        </Stack>
                    </Grid>

                    <Grid>
                        <Typography variant="h6" gutterBottom
                            sx={{
                                color: theme.palette.accent.main
                            }}>
                            Help
                        </Typography>
                        <Stack spacing={1} mx={1}>
                            <Link href="/faq">FAQ</Link>
                            <Link href="/resource-hub">Resources</Link>
                            <Link href="/site-map">Site Map</Link>
                        </Stack>
                    </Grid>

                    <Grid>
                        <Typography variant="h6" gutterBottom
                            sx={{
                                color: theme.palette.accent.main
                            }}>
                            Contact
                        </Typography>
                        <Stack spacing={1} mx={1}>
                            <Link href="/contact">Contact Us</Link>
                            <Link href="/support">Supporting Stylisher</Link>
                        </Stack>
                    </Grid>
                </Grid>

                <Box
                    sx={{
                        pt: 2,
                        mb: 1
                    }}
                >
                    <Typography variant="caption" >
                        Copyright 2000-2026 NeoPets, Inc. All rights reserved. Used with permission.
                    </Typography>
                </Box>
            </Box>
        </LocalLinkThemeWrapper>

    );
};

export default Footer;